import { render, staticRenderFns } from "./TransferIcon.vue?vue&type=template&id=7bfe7e7b&scoped=true&"
import script from "./TransferIcon.vue?vue&type=script&lang=js&"
export * from "./TransferIcon.vue?vue&type=script&lang=js&"
import style0 from "./TransferIcon.vue?vue&type=style&index=0&id=7bfe7e7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfe7e7b",
  null
  
)

export default component.exports